import { makeStyles } from "../Utilities/ThemeHelper";
const useStyles = makeStyles(theme => ({
  icon: {
    fontSize: theme.typography.fontSize,
    color: theme.palette.text.secondary,
    minWidth: 36,
    "& svg": {
      fontSize: theme.typography.fontSize
    }
  },
  alignEnd: {
    justifyContent: "flex-end"
  }
}));
export default useStyles;